// extracted by mini-css-extract-plugin
export default {"button":"Qi9vW","uzLang":"_yIs8","kkLang":"MT3rj","hasInCart":"s5Ek0","link":"eV6Bf"};